export default "__VITE_ASSET__BEZpziDL__"